module.exports = __webpack_public_path__ + "img/mh_w_logo.ef69e39d.png";